export const DEFAULT_SKILL_SUGGESTIONS = [
  'React',
  'Next.js',
  'TypeScript',
  'JavaScript',
  'Node.js',
  'Express',
  'NestJS',
  'Python',
  'Django',
  'Flask',
  'Java',
  'Spring Boot',
  'PHP',
  'Laravel',
  'Ruby on Rails',
  'Go',
  'Rust',
  '.NET',
  'C#',
  'C++',
  'HTML',
  'CSS',
  'Tailwind CSS',
  'SCSS',
  'Vue.js',
  'Angular',
  'Redux',
  'GraphQL',
  'REST APIs',
  'MySQL',
  'PostgreSQL',
  'MongoDB',
  'Redis',
  'Firebase',
  'Supabase',
  'AWS',
  'GCP',
  'Azure',
  'Docker',
  'Kubernetes',
  'CI/CD',
  'Git',
  'Linux',
  'React Native',
  'Flutter',
  'Swift',
  'Kotlin',
  'Figma',
  'UI/UX',
  'Photoshop',
  'Illustrator',
  'SEO',
  'WordPress',
  'Shopify',
  'Webflow',
  'QA',
  'Manual Testing',
  'Automation Testing',
  'Cypress',
  'Playwright',
  'Jest',
]
